// extracted by mini-css-extract-plugin
module.exports = {"centered":"AddRolesDialog-m__centered___2xApt","main":"AddRolesDialog-m__main___1bkx8","secondary":"AddRolesDialog-m__secondary___x2vdK"};